import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'ras-popup',
	templateUrl: './popup.component.html',
	styleUrls: ['./popup.component.sass']
})
export class PopupComponent implements OnInit {

	@Input() variation: string = ""
	public error = false
	@Input('error') set _error(value) {
		this.error = !(value === false)
	}

	@Output('close') close_emitter = new EventEmitter()
	public closing = false

	constructor() { }

	ngOnInit() {
	}

	close() {
		this.closing = true
		setTimeout(() => this.close_emitter.emit(), 700)
		
	}

}
